import { toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toast.styles.css'; // Import our custom toast styles
import React from 'react';
import ErrorToast from '../components/common/Toast/ErrorToast';
import { CheckCircle, XCircle, WarningCircle, Info } from '@phosphor-icons/react';

// App-wide defaults that can be overridden per entry (e.g., customers app)
let TOAST_DEFAULTS = {
  disableCopy: false,
};

export function setToastDefaults(overrides = {}) {
  try {
    TOAST_DEFAULTS = { ...TOAST_DEFAULTS, ...(overrides || {}) };
  } catch {
    // ignore
  }
}

// Default toast configuration
export const toastConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  transition: Flip, // 3D flip animation
  onClose: () => {},
  onOpen: () => {}
};

// Using Flip animation for all toasts

// Custom toast styles are now in toast.styles.css

// Helper functions for showing toasts
export const showToast = {
  success: (message) => toast.success(message, {
    ...toastConfig,
    icon: React.createElement(CheckCircle, { size: 20, weight: "bold" })
  }),
  error: (payload, options = {}) => {
    const disableCopy = Object.prototype.hasOwnProperty.call(options || {}, 'disableCopy')
      ? !!options.disableCopy
      : !!TOAST_DEFAULTS.disableCopy;
    // 1. Handle simple string messages
    if (typeof payload === 'string') {
      toast.error(payload, {
        ...toastConfig,
        icon: React.createElement(XCircle, { size: 20, weight: "bold" })
      });
      return;
    }

    // 2. For error objects, we now trust `payload.message` to be descriptive
    // thanks to the improvements in ApiResponseError.
    const message = payload?.message || 'A apărut o eroare neașteptată.';

    // For the "Copy Details" button, pass the entire original payload
    // to ensure the full stack trace is included.
    const errorDataForCopy = payload;

    const content = React.createElement(ErrorToast, { message, errorData: errorDataForCopy, disableCopy });
    toast.error(content, {
      ...toastConfig,
      icon: React.createElement(XCircle, { size: 20, weight: "bold" })
    });
  },
  info: (message) => toast.info(message, {
    ...toastConfig,
    icon: React.createElement(Info, { size: 20, weight: "bold" })
  }),
  warning: (message, options = {}) => toast.warning(message, {
    ...toastConfig,
    icon: React.createElement(WarningCircle, { size: 20, weight: "bold" }),
    ...options,
  }),
  // Counter flows save the sale even when SmartBill fails; the missing
  // invoice / bon must stay on screen until someone acknowledges it.
  saleSaved: (sale, successMessage) => {
    const warnings = sale?.document_warnings || [];
    if (warnings.length === 0) {
      showToast.success(successMessage);
      return;
    }
    showToast.warning(
      `Vânzare salvată, dar SmartBill nu a emis documentele — emiteți-le manual: ${warnings.join('; ')}`,
      { autoClose: false },
    );
  },
  loading: (message) => toast.loading(message, { ...toastConfig, autoClose: false }),
  dismiss: (toastId) => toast.dismiss(toastId),
};

export default showToast; 